import React, { useState } from 'react'
import { useResume } from '../ResumeProvider'
import { EditableHeading, newKey } from './common'
import { Button } from '../../../lib/ui/button'
import { PlusIcon } from '@heroicons/react/24/outline'
import { EditorItemProvider } from './EditorItemProvider'
import AwardItem from './AwardItem'
import { useTemplate } from '~/lib/pdf'
import { useTranslation } from '~/hooks/useTranslation'

const AwardsEditor = () => {
  const { t } = useTranslation('AwardsEditor')
  const { resumeDocument, setResumeDocument } = useResume()
  const [activeIndex, setActiveIndex] = useState(-1)
  const awards = resumeDocument?.awards || []

  const { editorFieldEnabled } = useTemplate()

  const addAward = () => {
    const newIndex = awards?.length || 0
    const updatedAward = [...awards, {}]

    setResumeDocument({ ...resumeDocument, awards: updatedAward })
    setActiveIndex(newIndex)
  }

  if (!editorFieldEnabled('awards')) return null

  return (
    <div className="flex flex-col">
      <div className="mb-4 flex flex-row">
        <EditableHeading
          title={t('awards')}
          description={t('awards_description')}
          settingName="awardsHeading"
        />
      </div>
      <div className="pb-4 tracking-[0.024px]">{t('awards_instructions')}</div>
      {awards.map((award, index) => {
        award.key = award.key || newKey()
        return (
          <div key={award.key}>
            <EditorItemProvider
              sectionName="awards"
              index={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              item={award}
            >
              <AwardItem />
            </EditorItemProvider>
          </div>
        )
      })}
      <Button onClick={addAward} className="max-w-min">
        {t('add_achievement')}
        <PlusIcon className="ml-2 w-5" />
      </Button>
    </div>
  )
}
export default AwardsEditor
